import React, { useState } from "react";
import axios from "axios";
import config from "../config";
import "./ActionsList.css";

import i18n from "../i18n";
const tr = i18n.t.bind(i18n);
const ActionsList = ({ actions , setRefresh, isModal}) => {

  const [pendingActions, setPendingActions] = useState({});

  const handleCompleteAction = (id) => {
    if (pendingActions[id]) return; // Prevent duplicate clicks
  
    setPendingActions((prev) => ({ ...prev, [id]: true }));
  
    const timer = setTimeout(() => {
      axios.put(tr('{{API_BASE_URL}}/actions/{{id}}/complete', {
        API_BASE_URL: config.API_BASE_URL,
        id
      }))
        .then(() => {
          setRefresh((prev) => !prev);
        })
        .catch((error) => console.error("Error marking action as completed:", error))
        .finally(() => {
          setPendingActions((prev) => {
            const updated = { ...prev };
            delete updated[id]; // Remove action from pending after API call
            return updated;
          });
        });
    }, 6000); // 6 seconds for the animation
  
    setPendingActions((prev) => ({ ...prev, [id]: timer }));
  };

  const cancelCompleteAction = (id) => {
    if (pendingActions[id]) {
      clearTimeout(pendingActions[id]); // Cancel the scheduled request
  
      setPendingActions((prev) => {
        const updated = { ...prev };
        delete updated[id];
        return updated;
      });
    }
  };

  return actions && actions.length>0 && (
    <table className="service-events-table">
      <thead>
        <tr>
          <th>{tr('State')}</th>
          <th>{tr('Elapsed')}</th>
          <th style={{width: '100%'}}>{tr('Action')}</th>
          <th>{tr('From')}</th>
          <th>{tr('⇨')}</th>
          <th>{tr('Table(s)')}</th>
          {!isModal && (
            <>
              <th>{tr('Client')}</th>
              <th>{tr('Reservation')}</th>
              <th>{tr('Order')}</th>
            </>
          )}
          <th>{tr('Done')}</th>
        </tr>
      </thead>
      <tbody>
        {actions.map(action => {

          return (
            <tr key={action.id} style={{opacity: action.completed ? 0.15 : 1 }}>
              <td><div style={{float: 'right', marginBottom: '-4px', boxShadow: '2px 1px 2px gray', border: '1px solid gray', borderRadius: '10px', width: '18px', height: '18px', background: action.state_color}} title={action.state_name}></div></td>
              <td><i>{('0'+(Math.floor(action.elapsed/60))).slice(-2)}{tr('\':')}{('0'+(action.elapsed%60)).slice(-2)}"</i></td>
              {(() => {
                const from = (action.action_from || "").toLowerCase();
              
                // decide if we show an id chip
                let idChip = "";
                if (from === "bbq" && action.assignedmeat != null) {
                  idChip = String(action.assignedmeat).slice(-2);
                } else if (from === "kitchen" && action.assignedstate != null) {
                  idChip = String(action.assignedstate).slice(-2);
                } else if (from === "table" && action.message != null) {
                  idChip = action.message;
                } else if (from === "station" && action.message != null) {
                  // «Ready:» από πόστο παραγγελιοληψίας — το message έχει «πόστο: πιάτο»
                  idChip = action.message;
                }  // pass/others => no id
              
                return (
                  <td>
                    <b>
                      {action.description}
                      {idChip && (
                        <> <span style={{
                              color: "#1e40af",    // blue-800, reliable color
                              fontWeight: 600,
                              fontStyle: "normal"
                            }}>{idChip}</span></>
                      )}
                    </b>
                  </td>
                );
              })()}
              <td>{action.action_from}</td>
              <td>{tr('⇨')}</td>
              <td><b style={{float: 'left'}}>{action.table_numbers}</b></td>
              {!isModal && (
                <>
                  <td><i style={{whiteSpace: 'nowrap'}}>{action.client_lastname} {action.client_firstname}</i></td>
                  <td>{action.reservation_id}</td>
                  <td>{action.reservation_order || ''}</td>
                </>
              )}
              <td>
                {action.completed ? (
                  <span style={{ color: "darkGreen" }}>{action.completed.slice(11, -8)}</span>
                ) : (
                  pendingActions[action.id] ? (
                    <div className="progress-container" onClick={() => cancelCompleteAction(action.id)}>
                      <svg className="progress-circle" width="24" height="24" viewBox="0 0 36 36">
                        <circle cx="18" cy="18" r="16"></circle>
                      </svg>
                      <span className="progress-x">{"\u2716"}</span>
                    </div>
                  ) : (
                    (() => {
                      const keyTables = String(action.table_numbers || '').replace(/\s+/g, '');
                      const keyType   = String(action.action_type_id ?? action.type ?? '');
                      const doneKey   = tr('{{keyTables}}_{{keyType}}', {
                        keyTables,
                        keyType
                      });
                      return (
                        <b
                          style={{ cursor: "pointer", fontSize: "20px", color: "darkGreen", padding: "10px" }}
                          data-done-key={doneKey}
                          title={tr('Done')}
                          onClick={() => handleCompleteAction(action.id)}
                        >
                          {"\u2714"}
                        </b>
                      );
                    })()
                  )
                )}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default ActionsList;
